function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
import React, { Component } from "react";
import { Manager, Reference, Popper } from "react-popper";
import styled from "styled-components";
import propTypes from "prop-types";
import memoizeOne from "memoize-one";
var DropdownContainer = styled.div(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.components.dropdown.container;
});
var DropdownListStyles = styled.div(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.components.dropdown.list;
});
var Dropdown = /*#__PURE__*/ function(Component) {
    "use strict";
    _inherits(Dropdown, Component);
    var _super = _createSuper(Dropdown);
    function Dropdown() {
        _classCallCheck(this, Dropdown);
        var _this;
        _this = _super.apply(this, arguments);
        _this.state = {
            dropdownOpened: false
        };
        _this.dropdownRef = null;
        _this.bindRef = function(ref) {
            _this.dropdownRef = ref;
        };
        _this.toggleDropdown = function() {
            var dropdownOpened = _this.state.dropdownOpened;
            if (dropdownOpened) {
                document.removeEventListener("click", _this.clickAwayListener);
            } else {
                document.addEventListener("click", _this.clickAwayListener);
            }
            _this.setState({
                dropdownOpened: !dropdownOpened
            });
        };
        // Closes the dropdown if the clicked element is not a descendant
        _this.clickAwayListener = function(e) {
            var ref;
            var shouldCloseOnClick = _this.props.shouldCloseOnClick;
            if (!((ref = _this.dropdownRef) === null || ref === void 0 ? void 0 : ref.contains(e.target)) || shouldCloseOnClick) {
                _this.toggleDropdown();
            }
        };
        _this.DropdownTrigger = function(props) {
            return /*#__PURE__*/ React.createElement(Reference, null, function(param) {
                var ref = param.ref;
                return /*#__PURE__*/ React.createElement("div", _extends({}, props, {
                    ref: ref,
                    className: "dropdown-trigger",
                    onClick: _this.toggleDropdown
                }));
            });
        };
        _this.getDropdownStyles = memoizeOne(function(style, props) {
            return _objectSpreadProps(_objectSpread({}, style), {
                zIndex: props.zIndex
            });
        });
        _this.DropdownContent = function(param) {
            var children = param.children, _className = param.className, className = _className === void 0 ? "" : _className, dataPlacement = param.placement, modifiers = param.modifiers;
            var dropdownOpened = _this.state.dropdownOpened;
            return /*#__PURE__*/ React.createElement(Popper, {
                strategy: _this.props.strategy,
                placement: dataPlacement,
                modifiers: modifiers,
                "data-display": "static"
            }, function(param) {
                var ref = param.ref, style = param.style, placement = param.placement;
                return dropdownOpened && /*#__PURE__*/ React.createElement("div", {
                    ref: ref,
                    style: _this.getDropdownStyles(style, _this.props),
                    "data-display": "static",
                    "data-placement": placement,
                    className: "dropdown-list ".concat(className)
                }, children);
            });
        };
        _this.DropdownList = function(param) {
            var children = param.children, _className = param.className, className = _className === void 0 ? "" : _className, dataPlacement = param.placement, modifiers = param.modifiers;
            var dropdownOpened = _this.state.dropdownOpened;
            var strategy = _this.props.strategy;
            return /*#__PURE__*/ React.createElement(Popper, {
                strategy: strategy,
                placement: dataPlacement,
                modifiers: modifiers,
                "data-display": "static"
            }, function(param) {
                var ref = param.ref, style = param.style, placement = param.placement;
                return dropdownOpened && /*#__PURE__*/ React.createElement(DropdownListStyles, {
                    ref: ref,
                    style: _this.getDropdownStyles(style, _this.props),
                    "data-display": "static",
                    "data-placement": placement,
                    className: "dropdown-list ".concat(className)
                }, children);
            });
        };
        return _this;
    }
    var _proto = Dropdown.prototype;
    _proto.componentWillUnmount = function componentWillUnmount() {
        document.removeEventListener("click", this.clickAwayListener);
    };
    _proto.render = function render() {
        return /*#__PURE__*/ React.createElement(Manager, null, /*#__PURE__*/ React.createElement(DropdownContainer, {
            ref: this.bindRef,
            className: "dropdown"
        }, this.props.children({
            DropdownTrigger: this.DropdownTrigger,
            DropdownList: this.DropdownList,
            DropdownContent: this.DropdownContent
        })));
    };
    return Dropdown;
}(Component);
Dropdown.propTypes = {
    shouldCloseOnClick: propTypes.bool,
    children: propTypes.func.isRequired,
    strategy: propTypes.string,
    zIndex: propTypes.number
};
Dropdown.defaultProps = {
    shouldCloseOnClick: true,
    strategy: undefined,
    zIndex: undefined
};
export default Dropdown;
